module.exports = __webpack_public_path__ + "static/img/1720_phase_function_Paper_PointsHejduk_Prediction.614e473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1720_phase_function_Paper_PointsHejduk_Prediction.png
// module id = PDPL
// module chunks = 0